import { useState, useEffect } from "react";
import { BookOpen, X, Loader2 } from "lucide-react";

const PDFViewer = ({
  url,
  page = 1,
  filename = "Document.pdf",
  isOpen = false,
  onClose,
  className = "",
  widthMode = "half", // "half" = legacy 50% split (ChatPage); "fill" = 100% of parent (HermesPage wrapper controls width/overlay)
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (url) {
      setIsLoading(true);
    }
  }, [url, page]);

  if (!url || !isOpen) return null;

  const outerStyle =
    widthMode === "fill"
      ? { width: "100%", height: "100%", overflow: "hidden" }
      : { width: isOpen ? "50%" : "0", flex: isOpen ? "1" : "0 0 auto", overflow: "hidden" };

  return (
    <div
      className={`flex flex-col h-full bg-white border-l border-gray-200 transition-all duration-300 ease-in-out ${className}`}
      style={outerStyle}
    >
      <div className="p-4 border-b border-gray-200 bg-white flex-shrink-0">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            PDF
          </h3>
        </div>
      </div>
      <div className="flex flex-col flex-1 w-full bg-gray-100 pl-2 overflow-hidden relative">
        {/* Document Header */}
        <div className="flex items-center justify-between px-2 py-2 border-b border-gray-100 shadow-sm flex-shrink-0 z-10">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700 truncate">
            <BookOpen size={16} className="text-blue-600 flex-shrink-0" />
            <span className="truncate" title={filename}>
              {filename}
            </span>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-gray-600"
          >
            <X size={16} />
          </button>
        </div>

        {/* Iframe Container */}
        <div className="flex-1 relative w-full h-full bg-white border-x border-b border-gray-200 shadow-sm mb-2 overflow-hidden">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
              <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
            </div>
          )}
          <iframe
            key={`${url}-${page}`}
            src={`${url}#page=${page}&toolbar=0&navpanes=0&scrollbar=0`}
            className="w-full h-full border-none absolute inset-0"
            title="PDF Viewer"
            onLoad={() => setIsLoading(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
